import React, { useState } from 'react'
import { IoIosWarning } from 'react-icons/io'
import { useTranslation } from 'react-i18next'
import Modal from './MyModal'
import MyButton from './buttons'
import { Link, useNavigate } from 'react-router-dom'

interface PracticeWarningProps {
  practiceName: string
}

const practicesWithWarning = [
  'cunnilingus',
  'sex-without-condom',
  'bondage-master',
  'bondage-slave',
  'sm-slave-soft',
  'sm-slave-hard',
  'master-sm-soft',
  'master-sm-hard',
  'blowjob-without-condom',
  'cum-in-mouth',
]

export const PracticesWarnings: React.FC<PracticeWarningProps> = ({
  practiceName,
}) => {
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false)
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleHelpClick = (e: React.MouseEvent) => {
    e.preventDefault()
    navigate('/help', {
      state: {
        searchTerm: t('helpData.sections.features.trafficking.question'),
      },
    })
  }

  const handleWarningClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    setIsWarningModalOpen(true)
  }

  if (!practicesWithWarning.includes(practiceName)) {
    return null
  }

  return (
    <>
      <IoIosWarning
        className='text-redpink cursor-pointer ml-2  inline-block absolute right-1/2 translate-x-1/2 -top-1'
        onClick={handleWarningClick}
      />
      <Modal
        isOpen={isWarningModalOpen}
        onClose={() => setIsWarningModalOpen(false)}
      >
        <div className='bg-white rounded-lg text-left'>
          <h2 className='text-xl font-bold mb-2 bg-anthracite text-white text-center p-2 rounded-t-lg'>
            {t('risky-sex-title')}
          </h2>
          <div className='p-4 space-y-4'>
            <p>{t('safety.warning.risks')}</p>
            <p>{t('safety.warning.screening')}</p>
            <ul className='list-disc pl-5 space-y-2'>
              <li>
                {t('safety.warning.option1_start')}{' '}
                <a
                  href='https://www.itg.be/fr/clinics/notre-structure-et-nos-activites'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-redpink hover:underline'
                >
                  {t('safety.warning.helpcenter')}
                </a>
                {t('safety.warning.option1_end')}
              </li>
              <li>{t('safety.warning.option2')}</li>
            </ul>
            <p className='font-semibold'>{t('safety.warning.trafficking')}</p>
            <p>{t('safety.warning.help')}</p>
            <p>{t('safety.warning.safety')}</p>
            <p className='text-anthracite py-2 px-4 bg-grisclair rounded-lg'>
              {t('safety.warning.alert')}{' '}
              <a
                href='#'
                onClick={handleHelpClick}
                className='text-redpink hover:underline'
              >
                {t('safety.warning.link')}
              </a>
            </p>
            <div className='w-full text-center pt-4'>
              <MyButton
                variant='redpink-anthracite'
                onClick={() => setIsWarningModalOpen(false)}
              >
                {t('close')}
              </MyButton>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export const hasPracticesWarnings = (practiceName: string) =>
  practicesWithWarning.includes(practiceName)
